// src/components/Layout/AddUser/AddUser.jsx
import React, { useEffect } from "react";
import { FormAddUserScheme } from "../../../Models/Schemas/add-user";
import { FORM_ADDUSER } from "../../../Constants/AddUser";
import Button from "../../Elements/Button/Button";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useForm from "../../../Hooks/useForm";
import Input from "../../Elements/Input/Input";
import Loader from "../../Elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import "./addUser.css";
import { useNavigate } from "react-router-dom";

// ── UTILITY: obtener username del JWT ─────────────────────────────
const getLoggedUsername = () => {
  try {
    const raw = localStorage.getItem("logindata");
    if (!raw) return null;
    const { data: { token } = {} } = JSON.parse(raw);
    if (!token) return null;
    const [, payload] = token.split(".");
    return JSON.parse(window.atob(payload)).username;
  } catch {
    return null;
  }
};

const AddUser = () => {
  const showToast = useToast();
  const { fetchAddUserData, loading, error, resetError } = useStore();
  const navigate = useNavigate();
  const loggedUsername = getLoggedUsername(); // <-- Aquí

  useEffect(() => {
    if (error) {
      showToast("error", error.message || "Error al agregar usuario");
      resetError();
    }
  }, [error, showToast, resetError]);

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    isValid,
    resetForm,
  } = useForm(FORM_ADDUSER, FormAddUserScheme);

  const sendAddUserData = async () => {
    try {
      const { confirmPassword, ...payload } = values;
      const result = await fetchAddUserData(payload);
      showToast("success", result?.message || "Usuario registrado con éxito");
      resetForm();
      navigate("/");
    } catch (e) {
      console.error(e);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="add-user-wrapper container-home">
      <div className="form-add-user">
        <h4>Agregar Usuario</h4>
        <form>
          <Input
            value={values.username}
            label="Usuario"
            onChange={handleChange("username")}
            onBlur={handleBlur("username")}
            error={setErrorFormSimpleUtil(errors, touched, "username")}
            success={!setErrorFormSimpleUtil(errors, touched, "username")}
          />
          <Input
            value={values.password}
            label="Contraseña"
            onChange={handleChange("password")}
            onBlur={handleBlur("password")}
            error={setErrorFormSimpleUtil(errors, touched, "password")}
            success={!setErrorFormSimpleUtil(errors, touched, "password")}
            variant="Password"
          />
          <Input
            value={values.confirmPassword}
            label="Confirmar Contraseña"
            onChange={handleChange("confirmPassword")}
            onBlur={handleBlur("confirmPassword")}
            error={setErrorFormSimpleUtil(errors, touched, "confirmPassword")}
            success={!setErrorFormSimpleUtil(errors, touched, "confirmPassword")}
            variant="Password"
          />

          {loggedUsername === "Administrador" ? (
            <div className="form-group mt-3">
              <label>Rol</label>
              <select
                className="form-control"
                name="role"
                value={values.role}
                onChange={handleChange("role")}
                onBlur={handleBlur("role")}
              >
                <option value="user">User</option>
                <option value="admin">Admin</option>
              </select>
              {touched.role && errors.role && (
                <small className="text-danger">{errors.role}</small>
              )}
            </div>
          ) : (
            <Input
              value={values.role}
              label="Rol"
              disabled
            />
          )}

          <center>
            <Button
              text="Agregar Usuario"
              color="green"
              fill
              action={sendAddUserData}
              disabled={!isValid}
              classNames="mt-3"
            />
          </center>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
